/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "client/template",
    "component!base",
    "underscore",
    "jquery",
    "jquery-ui-sortable"
  ], function(
    Template,
    ComponentBase,
    _,
    $
  ) {

    var SpanTemplate = Template.extend({

      initialize: function () {
        Template.prototype.initialize.apply(this, _.toArray(arguments));
        this.editable = false;
        this.$el = $(this.el);
      },

      hasContent: function() { return false },
      getContentSchema: function() {
        return  {
          type: "template"
        };
      },

      getContent: function() { return this.children[0].template; },

      createView: function(options)  {
        var view = new AddView(_.extend({}, options, {
              application: options.application,
              template: this,
              el: this.el,
        }));
        this.instances.push(view);
        // TODO: here??
        view.render();
       _.forEach(options.node.children, function (childNode) {
         childNode.template.createView(_.extend({}, options, {
           node: childNode,
         }));
       });
        return view;
      }
  });

  var AddView = ComponentBase.extend({

    initialize: function (args) {
      ComponentBase.prototype.initialize.apply(this, _.toArray(arguments));

      // call editor initially
      if (this.options.application.editor && !this.options.application.editor.addHandled) {
        this.options.application.editor.addHandled = true;
        this.options.application.editor.defaultParent = this.el;
        var that = this;
        window.setTimeout(function() {
          that.add({ el: that.el });
        }, 0);
      }
    },
    getEditControls: function() {},
    add: function(options) {
      options = options || {};
      
      if (!this.chooser) {
        var that = this;
        this.options.application.showPicker(
          this.options.application.editor.getAdders(this.options.model),
          this.options.node,
          this.container,
          $(_.values(AddView._sortables))
        );

        // add mb-selected class to highlight selected/active element
        var selectedElement = $(".mb-selected");
        selectedElement.removeClass("mb-selected");
        if (options.el === this.el) {
          this.$el.addClass("mb-selected");
        }
      }

      if (options.hidePicker) {
        this.options.application.editor.remove({ keepSelectedElementSelected: true });
      }
    },
    render: function() {
      if (!this.options.node.readonly) {
        var that = this,
          container = this.make("div", { class: "mb-adder" });
        var add = this.make("a", { class: "mb-add" });

        add.addEventListener("click", function(event) {
          var options = { el: that.el };
          if (event.isTrusted) {
            // hide picker as user wants to add a new widget
            options.hidePicker = true;
          }
          that.add(options);
        });

        container.appendChild(add);
        this.container = container;

        add.innerHTML = '<i class="fas fa-plus"></i>';

        // todo: track in application?
        // this.options.application
        AddView._sortables = AddView._sortables || {};
        AddView._sortables[this.cid] = this.el;

        var sortables = $(_.values(AddView._sortables)),
          application = this.options.application;

        this.$el.sortable({
          placeholder: "well",
          scroll: true,
          handle: ".mb-drag-handle",
          connectWith: sortables,
          tolerance: "pointer",
          items: "> *:not(.mb-adder)"
        });

        sortables.sortable("option", "connectWith", sortables);

        this.appendChild(container, true);

        this.addButton = add;
      }
    
      return this.el;
    },

    remove: function() {
      try {
        this.$el.sortable("destroy");
      } catch (e) {
        // ignore not initialized
      }
      if (this.chooser) {
        this.chooser.remove();
      }
      AddView._sortables && delete AddView._sortables[this.cid];
      ComponentBase.prototype.remove.apply(this, _.toArray(arguments));
    } });

  return SpanTemplate;
});
